import { render, staticRenderFns } from "./article-category.vue?vue&type=template&id=bba98f94&scoped=true&"
import script from "./article-category.vue?vue&type=script&lang=js&"
export * from "./article-category.vue?vue&type=script&lang=js&"
import style0 from "./article-category.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./article-category.vue?vue&type=style&index=1&id=bba98f94&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba98f94",
  null
  
)

export default component.exports